import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { normalize, schema } from 'normalizr';
import { Alert } from 'react-bootstrap';
import { loadEnrolments, exportEnrolments, exportBadges } from './actions';
import { loadUnpagedGrades } from '../grades/actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';

export const submitMode = {
	LIST: 'list',
	EXCEL: 'excel',
	PDFBADGES: 'pdfBadges'
}
class Enrolments extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: [],
			error: null
		};
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
		this.props.loadUnpagedGrades();
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter, mode) {
		const { t } = this.props;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.setState({ selectedEntities: [] });
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		this.setState({ error: null });

		if (mode === submitMode.PDFBADGES) {
			if (!filter || !filter.centerId) {
				this.setState({ error: t('Enrolment_GenerateBadgesCenterRequired') });
			}
			this.exportData(filter, 'Badges');
		}
		else if (mode === submitMode.EXCEL) {
			this.exportData(filter, 'Excel');
		}
	}

	exportData(filter, exportFormat) {
		if (exportFormat == 'Badges') {
			this.props.exportBadges(filter)
		}
		else {
			this.props.exportEnrolments(filter);
		}
	}

	handleFilterReset() {
		this.handleFilterSubmit();
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.selectedParentIds() }, onSuccess);
	}

	selectedParentIds() {
		return [...new Set(this.state.selectedEntities.map(item => item.parent.id))]
	}

	normalizeData(payments) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const payment = new schema.Entity('paymentHistories', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(payments, [payment]);
		return normalizedData;
	}

	renderListActions() {
		const { canSendMessage } = this.props;

		const normalizedData = this.normalizeData(this.state.selectedEntities);
		const parents = normalizedData && normalizedData.entities && normalizedData.entities.parents;

		return <React.Fragment>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={parents && Object.values(parents).map(p => ({ name: p.fullname, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</React.Fragment>
	}

	render() {
		const { isReadonly, paymentTypes, grades, canSendMessage, requireAddress, requirePostcode, requireChildSchool, enableAutoEnrolment } = this.props;
		return (
			<div>
				{this.state.error && <Alert bsStyle='danger'>{this.state.error}</Alert>}
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} paymentTypes={paymentTypes} grades={grades} enableAutoEnrolment={enableAutoEnrolment} loading={this.props.pagination.loading || this.props.enrolmentsExport.loading || this.props.badgesExport.loading}/>
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={this.renderListActions()} canSendMessage={canSendMessage}
					requireAddress={requireAddress} requirePostcode={requirePostcode} requireChildSchool={requireChildSchool}
					enableAutoEnrolment={enableAutoEnrolment}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		exports,
		entities: { enrolments, grades },
		lookups: { paymentTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const enrolmentsPagination = pagination.enrolments.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const enrolmentsExport = exports.enrolments.all || {};
	const badgesExport = exports.badges.all || {};

	return {
		data: enrolmentsPagination.ids.map(id => enrolments[id]),
		pagination: enrolmentsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		paymentTypes,
		grades,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		requireAddress: franchisor.requireAddress,
		requirePostcode: franchisor.requirePostcode,
		requireChildSchool: franchisor.requireChildSchool,
		enableAutoEnrolment: franchisor.enableAutoEnrolment,
		enrolmentsExport,
		badgesExport
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadEnrolments,
	initializeFilter: (data, fields) => initialize('enrolmentsFilter', data, fields),
	exportEnrolments,
	loadUnpagedGrades,
	exportBadges,
	sendMessage
})(withTranslation()(Enrolments));